import React, { useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import PsaFormDispatcher from "../forms/PsaFormDispatcher";
import { usePsaProjectMutations } from "../api/usePsaProjectMutations";
import { ResolvedIntegration } from "../types/PsaProject";
import useStyles from "../styles/useStyles";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { handleAlert } from "@utils/helperFunctions";

interface Props {
  projectId: string;
  integration: ResolvedIntegration;
  record: any;
  canManage: boolean;
}

const Edit: React.FC<Props> = ({
  projectId,
  integration,
  record,
  canManage,
}) => {
  const styles = useStyles();
  const { update } = usePsaProjectMutations();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [showError, setShowError] = useState(false);
  const errorMessage = record?.attributes?.["error-message"];

  const resubmit = async () => {
    setBusy(true);
    try {
      await update(projectId, {
        data: { type: "psa-projects", attributes: {} },
      });
      window.location.assign(`/projects/${projectId}/edit`);
    } catch (err: any) {
      setError(
        err?.data?.errors?.[0]?.detail ||
          "Something went wrong. Your changes could not be saved."
      );
      setShowError(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.page}>
      {handleAlert(showError, error, setShowError, "warning", ToastAlert)}
      <Card className={styles.card}>
        <Card.Header className={styles.cardHeader}>
          <Row className={styles.headerRow}>
            <Col sm={1}>
              <Button
                className="btnSeawhite"
                onClick={() =>
                  window.location.assign(`/projects/${projectId}/edit`)
                }
              >
                Cancel
              </Button>
            </Col>
            <Col className={styles.title} sm={8}>
              PSA Project
            </Col>
            {canManage && (
              <Col>
                <Button
                  className="squareGreenButton floatRight"
                  disabled={busy}
                  onClick={resubmit}
                >
                  Resubmit to PSA
                </Button>
              </Col>
            )}
          </Row>
        </Card.Header>
        <hr className={styles.hr} />
        {errorMessage && (
          <div className={styles.banner}>
            Could not create PSA project. {errorMessage}
          </div>
        )}
        <Card.Body>
          <PsaFormDispatcher
            integration={integration}
            projectId={projectId}
            record={record}
            readOnly
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default Edit;
